var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearCache({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734621890610,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 86832,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.824 574.464h679.168c22.4 0 33.088-15.872 23.488-35.328L812.352 376.32c-9.6-19.456-35.776-35.328-58.176-35.328H613.76v-238.08c0-21.504-18.176-38.912-41.088-38.912H491.52c-22.4 0-41.152 17.408-41.152 38.912v238.592H305.152c-22.4 0-48.64 15.872-58.24 35.328l-80 162.816c-10.24 18.944 0.512 34.816 22.912 34.816z m660.992 57.856H224c3.2 60.416 2.112 132.608-50.176 175.616-73.152 59.904-48.64 125.952 3.2 152.064h106.24c10.688-13.824 68.352-91.648 84.928-170.496 2.624-16.384 4.224-27.136 4.224-27.136-0.512 9.216-2.112 17.92-4.224 27.136-8.064 50.176-26.24 153.6-39.552 170.496h76.864c10.688-13.824 68.352-91.648 84.928-170.496 2.688-16.384 4.288-27.136 4.288-27.136-0.576 9.216-2.176 17.92-4.288 27.136-8 50.176-26.176 153.6-39.488 170.496h97.152c10.688-13.824 68.352-91.648 84.864-170.496 2.688-16.384 4.288-27.136 4.288-27.136-0.512 9.216-2.112 17.92-4.288 27.136-8 50.176-26.112 153.6-39.488 170.496h97.152c10.688-13.824 68.352-91.648 84.928-170.496 2.624-16.384 4.224-27.136 4.224-27.136-0.512 9.216-2.112 17.92-4.224 27.136-8 50.176-26.176 153.6-39.552 170.496h98.24s64.64-22.016 54.464-93.696c-12.8-101.376-18.688-158.208-37.888-233.984z",
    fill: "currentColor",
    "p-id": 86833
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCache);
export default __webpack_public_path__ + "static/media/clear-cache.edaaed0bb929870839937f82df5956f1.svg";
export { ForwardRef as ReactComponent };